/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit, signal} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

import template from './elections-list-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';
import {ElectionApiService} from '../../common/controller/election-api.service';

function isCurrentElection(election: any): boolean {
  if (!election.electionDate) {
    return true;
  }

  return moment(election.electionDate).startOf('day').isSameOrAfter(moment().startOf('day'));
}

function sortElections(elections: any[]): any[] {
  return _.orderBy(elections || [], [
    function(election) {
      return election.electionDate ? 0 : 1;
    },
    'electionDate',
    function(election) {
      return (election.name || '').toLowerCase();
    }
  ]);
}

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-elections-list-page',
  template
})
export class ElectionsListPageComponent implements OnInit {
  readonly loaded = signal(false);
  includeTestOnly = false;
  showPastElections = false;
  readonly allElections = signal<any[]>([]);
  readonly elections = signal<any[]>([]);

  constructor(private readonly electionApi: ElectionApiService) {
  }

  ngOnInit(): void {
    this.loadElections();
  }

  applyFilters(): void {
    this.elections.set(sortElections(_.filter(this.allElections(), (election) => {
      if (!this.includeTestOnly && election.testOnly) {
        return false;
      }
      if (!this.showPastElections && !isCurrentElection(election)) {
        return false;
      }
      return true;
    })));
  }

  loadElections(): void {
    this.loaded.set(false);

    this.electionApi.list({includeTests: true}).subscribe({
      next: (data: any) => {
        this.allElections.set(data.results || []);
        this.applyFilters();
        this.loaded.set(true);
      },
      error: () => {
        this.allElections.set([]);
        this.elections.set([]);
        this.loaded.set(true);
      }
    });
  }
}
